import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../hooks/useAppSelector';
import { selectSpecificTenant } from '../redux';

interface SingleTenantProtectedRouteProps {
  children: React.ReactElement;
}

/**
 * Blocks routes that only make sense inside one tenant. Viewing "all tenants"
 * (or having nothing selected) sends the user back to the index route, which
 * picks a landing page for them.
 *
 * Renders after the app reaches `READY`, so the selection has already settled and
 * a `null` here means "all tenants" rather than "still loading".
 */
export function SingleTenantProtectedRoute({ children }: SingleTenantProtectedRouteProps) {
  const tenant = useAppSelector(selectSpecificTenant);

  if (tenant == null) return <Navigate to="/" replace />;

  return children;
}

export default SingleTenantProtectedRoute;
